import {IssueDraftIcon} from '@primer/octicons-react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {ConvertedFromDraftEvent$key} from './__generated__/ConvertedFromDraftEvent.graphql'
import {TimelineRow} from './row/TimelineRow'

type ConvertedFromDraftEventProps = {
  queryRef: ConvertedFromDraftEvent$key
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function ConvertedFromDraftEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: ConvertedFromDraftEventProps): React.ReactElement {
  const {actor, createdAt, databaseId} = useFragment(
    graphql`
      fragment ConvertedFromDraftEvent on ConvertedFromDraftEvent {
        createdAt
        actor {
          ...TimelineRowEventActor
        }
        databaseId
      }
    `,
    queryRef,
  )

  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={IssueDraftIcon}
    >
      <TimelineRow.Main>{`${LABELS.timeline.convertedFromDraftIssue} `}</TimelineRow.Main>
    </TimelineRow>
  )
}

try{ ConvertedFromDraftEvent.displayName ||= 'ConvertedFromDraftEvent' } catch {}